import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Placeholder from 'components/consumer/Placeholder';
import loadable from '@loadable/component';
import useScreen from 'hooks/useScreen';
import PDPAvailableInSizesRow from './PDPAvailableInSizesRow';
import PDPAvailableInSizesListItem from './PDPAvailableInSizesRow/PDPAvailableInSizesListItem';

const AnimateHeight = loadable(() => import('react-animate-height'));

const MOBILE_AND_TABLET_DURATION = 300;
const DESKTOP_DURATION = 500;

const PDPAvailableInSizesUI = ({
  buildYourOwnDetails = {},
  currentProductId,
  initialIsExpanded = false,
  loading,
  pdpIsModularBYOProduct = false,
  products,
  removeUnavailableProductId = () => {},
  showBYOSize = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(initialIsExpanded);

  const { isMobileOrTablet } = useScreen();

  const duration = isMobileOrTablet
    ? MOBILE_AND_TABLET_DURATION
    : DESKTOP_DURATION;

  if (loading) {
    return (
      <div className="mb-3 md:mb-6">
        <Placeholder
          type="rect"
          loading
          style={{ width: '35%', height: 10, marginTop: 18 }}
        />
      </div>
    );
  }

  if (!products?.length || !currentProductId) {
    return <div />; // Probably to fix an SSR, return the same number of divs on client & server
  }

  return (
    <div className="mb-3 md:mb-6">
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        className="inline-block text-sm font-bold text-brand cursor-pointer mt-1 md:mt-0"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {!pdpIsModularBYOProduct
          ? `Available in ${products.length} sizes ${isExpanded ? '-' : '+'}`
          : `Also available in ${products.length} configurations ${
              isExpanded ? '-' : '+'
            }`}
      </div>

      <AnimateHeight duration={duration} height={isExpanded ? 'auto' : 0}>
        {products
          .sort((a, b) => a.id - b.id)
          .map(({ id, slug }) => (
            <PDPAvailableInSizesRow
              id={id}
              isActive={id === currentProductId}
              key={id}
              pdpProductId={currentProductId}
              productsData={products}
              removeUnavailableProductId={removeUnavailableProductId}
              slug={slug}
            />
          ))}
        {showBYOSize ? (
          <PDPAvailableInSizesListItem
            byoCollectionName={buildYourOwnDetails.name}
            dimensions={buildYourOwnDetails.dimensions || ''}
            id="byo"
            image=""
            isActive={false}
            isBYO
            loading={false}
            name={`Build your own ${buildYourOwnDetails.name}`}
            price=""
            urlKey={buildYourOwnDetails.urlKey}
          />
        ) : null}
      </AnimateHeight>
    </div>
  );
};

PDPAvailableInSizesUI.propTypes = {
  buildYourOwnDetails: PropTypes.shape({
    dimensions: PropTypes.string,
    name: PropTypes.string,
    urlKey: PropTypes.string,
  }),
  currentProductId: PropTypes.number,
  initialIsExpanded: PropTypes.bool,
  loading: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      slug: PropTypes.string,
    })
  ),
  removeUnavailableProductId: PropTypes.func,
  showBYOSize: PropTypes.bool,
};

export default PDPAvailableInSizesUI;
